<div class="container-fluid space-1" >
  <div class="row">
    <div class="col-12 text-center">
      <h4>Connecting to event....</h4>
    </div>
  </div>
<h1><page-load-header *ngIf="!errorMessage"></page-load-header></h1>

  <div class="alert alert-danger text-center" *ngIf="errorMessage">
    <h4 class="alert-heading">Error</h4>
    {{ errorMessage }}
  </div>
</div>
